import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Modal,
  Typography,
} from '@mui/material';
import React, { FunctionComponent, useMemo } from 'react';

import { ConfirmUserHereWithCodeMutation } from '../../../../apollo/__generated__/graphql';

interface UserRecapModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: ConfirmUserHereWithCodeMutation['confirmUserHere'] | null;
}

export const UserRecapModal: FunctionComponent<UserRecapModalProps> = ({
  isOpen,
  onClose,
  user,
}) => {
  const userProfileErrors = useMemo(() => {
    if (!user) {
      return [];
    }

    let errors: string[] = [];

    if (!user.hasPaidTicket) {
      errors.push("L'utilisateur n'a pas payé. Voir avec un orga");
    }

    if (!user.hasCaution) {
      errors.push(
        "L'utilisateur n'a pas donné sa caution. Demandez-lui de la donner.",
      );
    }

    if (!user.isValidated) {
      errors.push("L'utilisateur n'est pas validé. Voir avec un orga.");
    }

    return [];
  }, [user]);

  return (
    <Modal open={isOpen} onClose={onClose}>
      {user ? (
        <Box
          sx={{
            p: 4,
            bgcolor: userProfileErrors.length > 0 ? 'red' : 'green',
            height: '100%',
          }}
        >
          <Card sx={{ mb: 2 }}>
            <CardContent>
              <Typography variant="h6" component="h2">
                {user.firstname} {user.lastname} ({user.nickname})
              </Typography>
              <Typography sx={{ mt: 2 }}>
                {user.studyTown} -{' '}
                {user.isNoAlcool ? 'Bacchus Troué' : 'Avec alcool'}
              </Typography>
            </CardContent>
          </Card>

          {user.orgaComment && user.orgaComment.length > 0 ? (
            <Card sx={{ mb: 2 }}>
              <CardContent>
                <Typography variant="h6" component="h2">
                  {`Commentaire de l'orga :`}
                </Typography>
                <Typography sx={{ mt: 2 }}>{user.orgaComment}</Typography>
              </CardContent>
            </Card>
          ) : null}

          {user.bedroom ? (
            <Card sx={{ mb: 2 }}>
              <CardContent>
                <Typography variant="h6" component="h2">
                  Chambre
                </Typography>
                <Typography>
                  {user.bedroom.doorNumber} - Étage {user.bedroom.floor}
                </Typography>
              </CardContent>
            </Card>
          ) : null}

          {user.pastEvents.length > 0 ? (
            <Card sx={{ mb: 2 }}>
              <CardContent>
                <Typography variant="h6" component="h2">
                  Événements précédents :
                </Typography>
                {user.pastEvents.map((pastEvent) => (
                  <Typography key={pastEvent.id}>- {pastEvent.name}</Typography>
                ))}
              </CardContent>
            </Card>
          ) : null}

          <Card sx={{ mb: 2 }}>
            <CardContent>
              {userProfileErrors.length > 0 ? (
                userProfileErrors.map((error) => (
                  <Typography key={error}>- {error}</Typography>
                ))
              ) : (
                <Typography variant="h6" component="h2">
                  Le dossier est complet !
                </Typography>
              )}
            </CardContent>
            <CardActions>
              <Button variant="contained" onClick={onClose}>
                Fermer
              </Button>
            </CardActions>
          </Card>
        </Box>
      ) : (
        <Box />
      )}
    </Modal>
  );
};
